// Flags de reversão da Fase B (doc mestre 2026-06-09, Seção 6/B6).
//
// TEASER_ENFORCED — liga o teaser anônimo (itens B2/B3):
//   - false (default): comportamento atual, nada muda.
//   - true: anônimo recebe score + contagens + 1 amostra; relatório completo
//     fica retido (blur + cadeado + CTA de cadastro).
//
// Como ligar:  VITE_TEASER_ENFORCED=true no Vercel + redeploy.
// ROLLBACK:    remover a env var (ou =false) + redeploy (~2 minutos).
// Critério de reversão (Seção 9): anônimo→cadastro abaixo do baseline ~2,4%
// por 1 semana (medir com functions/scripts/funnel-report.js).
export const TEASER_ENFORCED: boolean = (() => {
  try {
    // @ts-ignore - Vite environment
    return typeof import.meta !== 'undefined' && import.meta.env?.VITE_TEASER_ENFORCED === 'true';
  } catch {
    return false;
  }
})();

// B7 — Ramo de nota alta (Seção 5.1): score do scan a partir do qual a
// narrativa pivota para o match ("nota alta não converte por medo").
// Calibrar com o histograma de scores do funil (score_85_100 etc. — B1).
export const HIGH_SCORE_BRANCH = 85;
